var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.14645 8.64645C6.34171 8.45118 6.65829 8.45118 6.85355 8.64645L10 11.7929L13.1464 8.64645C13.3417 8.45118 13.6583 8.45118 13.8536 8.64645C14.0488 8.84171 14.0488 9.15829 13.8536 9.35355L10.3536 12.8536C10.1583 13.0488 9.84171 13.0488 9.64645 12.8536L6.14645 9.35355C5.95118 9.15829 5.95118 8.84171 6.14645 8.64645Z",
    fill: "#065B70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0fee9abb198e36d0441824ea2a85aca7.svg";
export { ForwardRef as ReactComponent };